import Staff from '../../organization_structure/personal_information_management';
import { Row, Col, Button, setParamsFilter, Typography, Form, Input, Select, Tag, DatePicker, Popconfirm, message, ExpandableText } from '../../ui/ot'
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCRUDController } from '../../ui/classify_structure/CRUDController';
import { useEffect } from 'react';
import dayjs from 'dayjs'
import UnsuspendModal from './unsuspend_modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import ReturnButton from './../components/return_button'
import SpecificUserOverdueModal from './specific_user_overdue_modal'
import StaffPatronProgressModal from './staff_patron_progress_modal'
import StaffPatronImportModal from './staff_patron_import_modal'
// 分館顏色的陣列
const colorPalette = [
    "#D32F2F", // 紅
    "#1976D2", // 藍
    "#388E3C", // 綠
    "#FBC02D", // 黃
    "#7B1FA2", // 紫
    "#F57C00", // 橘
    "#0097A7", // 青
    "#5D4037", // 咖啡
    "#C2185B", // 玫紅
    "#303F9F"  // 深藍
];
// 計算 branchcode 的 "簡單 index"
const getColorIndexFromBranchcode = (branchcode = "") => {
    if (!branchcode) return 0;
    let sum = 0;
    for (let i = 0; i < branchcode.length; i++) {
        sum += branchcode.charCodeAt(i);
    }
    return sum % colorPalette.length;
};

const getBranchColor = (branchcode) => {
    const index = getColorIndexFromBranchcode(branchcode);
    return colorPalette[index];
};
const StaffPatron = ({
    keyPrefix = "library.backstage.staff_patron",
    permission_level = null,
    readonly = false,
    onSelect = () => { },
    propsRowSelectionType = 'checkbox'
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [reloadCount, setReloadCount] = useState(0)
    const exportParams = useRef()
    const [search, setSearch] = useState({
        date_expiry_start: dayjs().format('YYYY-MM-DD'),
        date_expiry_end: dayjs().add(1, 'month').format('YYYY-MM-DD'),
    })
    const [exloading, setExLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const customFormItems = (fieldName) => {
        return (<Row>
            {/* <Col span={24}>
                <Form.Item
                    label={t('borrowernumber')}
                    name={"borrowernumber"}
                >
                    <Input disabled/>
                </Form.Item>
            </Col> */}
            <Col span={24}>

                <Form.List
                    name={[fieldName?.name ?? '', "additional_attributes"]}

                >
                    {(fields, { add, remove }) => (<>
                        <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'end' }}>

                            {fields?.map((field, key) => (<>
                                <Col span={24}>
                                    <Form.Item
                                        name={[field?.name ?? '', "id"]}
                                        hidden={true}
                                    >
                                        <div></div>
                                    </Form.Item>
                                    <Form.Item
                                        name={[field?.name ?? '', "code"]}
                                        hidden={true}
                                    >
                                        <div></div>
                                    </Form.Item>
                                    <Form.Item
                                        name={[field?.name ?? '', "options"]}
                                        hidden={true}
                                    >
                                        <div></div>
                                    </Form.Item>
                                    <Form.Item
                                        name={[field?.name ?? '', "repeatable"]}
                                        hidden={true}
                                    >
                                        <div></div>
                                    </Form.Item>
                                    <Form.Item
                                        name={[field?.name ?? '', "wantDelete"]}
                                        hidden={true}
                                    >
                                        <div></div>
                                    </Form.Item>
                                    <Form.Item
                                        label={field?.description}
                                        name={[field?.name ?? '', "attribute"]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        name={[field?.name ?? '', "description"]}
                                    >
                                        <div></div>
                                    </Form.Item>
                                </Col>
                            </>))}

                        </Row>

                    </>
                    )}
                </Form.List>
            </Col>
            {/* <Col span={24}>
                <Form.Item
                    label={t('cardnumber')}
                    name={[fieldName?.name ?? '', "cardnumber"]}
                >
                    <Input />
                </Form.Item>
            </Col> */}
            <Col span={24}>
                <Form.Item
                    label={t('branchname')}
                    name={[fieldName?.name ?? '', "branchcode"]}
                >
                    <Select
                        options={LibraryController.ResponseData.map((value) => {
                            return {
                                value: value?.branchcode,
                                label: value?.branchname
                            }
                        })}
                    />
                </Form.Item>
            </Col>
            {/* <Col span={24}>
                <Form.Item
                    label={t('borrowercategory')}
                    name={"categorycode"}
                >
                    <Select
                        options={BorrowerCategoryController.ResponseData.map((value) => {
                            return {
                                value: value?.categorycode,
                                label: value?.name
                            }
                        })}
                    />
                </Form.Item>
            </Col> */}
            <Col span={24}>
                <Form.Item
                    label={t('dateexpiry')}
                    name={[fieldName?.name ?? '', "dateexpiry"]}
                >
                    <Input type="date" />
                </Form.Item>
            </Col>
        </Row>)
    }
    const borrowerNoteFormItem = (fieldName) => {
        return (
            <Form.Item
                label={t('borrower_note')}
                name={[fieldName?.name ?? '', "borrower_note"]}
            >
                <Input.TextArea rows={3} />
            </Form.Item>
        )
    }
    const onFinish = ({ axiosMode, status, values, type }) => {
        if (status === "success") {
            if (axiosMode === "delete") {
                message.success("取消讀者停權成功")
                // actionRef.current.reloadAndRest();
                setReloadCount((pre) => pre + 1)
            }
        }
        else {
            if (axiosMode === "delete") {
                message.error("取消讀者停權失敗")
                // actionRef.current.reloadAndRest();
                setReloadCount((pre) => pre + 1)
            }
        }
    }
    const LibraryController = useCRUDController({
        apiRoute: "/koha/library"
    })
    const BorrowerCategoryController = useCRUDController({
        apiRoute: "/library/organization_structure/api/department?classify_structure_id=9&classify_structure_type_id=0"
    })
    const SuspensionController = useCRUDController({
        apiRoute: "/library/koha/suspension",
        onFinish: onFinish
    })
    const exportData = (data) => {
        let start_end = ""
        if (!!data?.date_expiry_start && !!data?.date_expiry_end) {
            let start = dayjs(data?.date_expiry_start).format("YYYYMMDD")
            let end = dayjs(data?.date_expiry_end).format("YYYYMMDD")
            start_end = `${start}-${end}`
        }
        setExLoading(true)
        axios.get(`/library/organization_structure/api/staff/concatenation_export/expiration_staff_with_uncheckins`,
            {
                responseType: 'blob',
                params: data,
            },
        )
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${start_end}到期讀者清單.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .finally(() => {
                setExLoading(false)
            })
    }

    useEffect(() => {
        LibraryController.getData()
        BorrowerCategoryController.getData()
    }, [])

    return (<Row>

        <Col span={24}>
            <Staff
                propsReloadCount={reloadCount}
                propsInitialValues={{
                    user_department_role_data: [{}],
                    serial_name_check: false,
                    dateexpiry: dayjs().add(2, 'year').format("YYYY-MM-DD"),
                    borrower_note: "",
                    additional_attributes: [{
                        "id": null,
                        "code": "mifare",
                        "options": [],
                        "attribute": null,
                        "repeatable": 0,
                        "wantDelete": 0,
                        "description": "卡片內碼"
                    }]
                }}
                propsRowSelectionType={propsRowSelectionType}
                onSelect={onSelect}
                readonly={readonly}
                keyPrefix={keyPrefix}
                staffApi="/library/organization_structure/api/staff/concatenation"  //staff 的api 名稱
                renderImportButton={() => <StaffPatronImportModal onQueued={() => setReloadCount(value => value + 1)} />}
                departmentApi='/library/organization_structure/api/department'
                customFormItems={(fieldName, formValues, onValuesChange, propsCustomForm, field, onFormFinish) => {
                    return (customFormItems(field))
                }} //上層可加入自定義的form item 
                customFormItemsAfterBirthday={(fieldName, formValues, onValuesChange, propsCustomForm, field, onFormFinish) => {
                    return borrowerNoteFormItem(field)
                }}
                customColumns={[
                    // {
                    //     title: t('borrowernumber'),
                    //     key: 'borrowernumber',
                    //     dataIndex: 'borrowernumber',
                    //     align: 'center',
                    // },
                    {
                        title: t('mifare'),
                        key: 'additional_attributes',
                        dataIndex: 'additional_attributes',
                        align: 'center',
                        render: (text, record, index) => {
                            if (!Array.isArray(text)) {
                                return <> </>
                            }
                            else {
                                let mifareData = (text || []).find((ele) => ele?.code === "mifare")
                                return <> {mifareData?.attribute || ""}</>
                            }

                        }
                    },
                    {
                        title: "停權狀態",
                        key: 'suspension',
                        dataIndex: 'suspension',
                        render: (text, record, index) => {
                            if (text === "停權") {
                                let description = "是否要取消停權?"
                                if (record?.checkout_data?.length) {
                                    // description += `讀者尚有${record?.checkout_data?.length}項館藏未歸還`
                                    let hasOverdue = record?.checkout_data.some(issue => issue.issue_days_due_status === "已逾期");
                                    let canUnsuspend = !hasOverdue
                                    return (<UnsuspendModal
                                        canUnsuspend={canUnsuspend}
                                        userRecord={record}
                                        propsIssueCardnumber={record?.cardnumber}
                                        propsButtonText={text}
                                        propsOnClose={() => {
                                            setReloadCount((pre) => pre + 1)
                                        }}
                                        propsUnsuspend={() => {
                                            if (record?.user_id && record?.borrowernumber) {
                                                SuspensionController.deleteData([{
                                                    user_id: record?.user_id,
                                                    borrowernumber: record?.borrowernumber
                                                }])
                                            }
                                            else {
                                                message.info("人員資料不完整，無法取消停權")
                                            }
                                        }}
                                    />)
                                }
                                else {
                                    return (<Popconfirm
                                        title="取消停權"
                                        description={description}
                                        onConfirm={() => {
                                            if (record?.user_id && record?.borrowernumber) {
                                                SuspensionController.deleteData([{
                                                    user_id: record?.user_id,
                                                    borrowernumber: record?.borrowernumber
                                                }])
                                            }
                                            else {
                                                message.info("人員資料不完整，無法取消停權")
                                            }
                                        }}
                                    >
                                        <Button type="link">
                                            {text}
                                        </Button>
                                    </Popconfirm>)
                                }
                            }
                            else {
                                return <Typography.P
                                    style={{
                                        color: '#1976D2'
                                    }}
                                >
                                    {text || "未停權"}
                                </Typography.P>
                            }
                        }
                    },
                    {
                        title: t('cardnumber'),
                        key: 'cardnumber',
                        dataIndex: 'cardnumber',
                        align: 'center',
                    },
                    {
                        title: t('branchcode'),
                        key: 'branchcode',
                        dataIndex: 'branchcode',
                        align: 'center',
                        render: (text, record, index) => {
                            const color = getBranchColor(record?.branchcode);
                            return <Typography.P
                                style={{
                                    color: color
                                }}
                            >
                                {text}
                            </Typography.P>
                        }
                    },
                    {
                        title: t('branchname'),
                        key: 'branchname',
                        dataIndex: 'branchname',
                        align: 'center',
                        render: (text, record, index) => {
                            const color = getBranchColor(record?.branchcode);
                            return <Typography.P
                                style={{
                                    color: color
                                }}
                            >
                                {text}
                            </Typography.P>
                        }
                    },
                    {
                        title: t('borrowercategory'),
                        key: 'categoryname',
                        dataIndex: 'categoryname',
                        align: 'center',
                    },
                    {
                        title: t('dateexpiry'),
                        key: 'dateexpiry',
                        dataIndex: 'dateexpiry',
                        align: 'center',
                        render: (text, record, index) => {
                            if (dayjs(text) >= dayjs()) {
                                return <Tag color="success">{text}</Tag>
                            }
                            else {
                                return <Tag color="error">{text}{t('expired')}</Tag>
                            }
                        }
                    },
                    {
                        title: t('uncheckin_amount'),
                        key: 'uncheckin_amount',
                        dataIndex: 'uncheckin_amount',
                        align: 'center',
                        render: (text, record, index) => {
                            let color = !!record?.checkout_data?.length ? "#984447" : "#476C9B"
                            return <Typography.P
                                style={{
                                    color: color
                                }}
                            >
                                {record?.checkout_data?.length} {t("book_unit")}
                            </Typography.P>
                        }
                    },
                    {
                        title: t('uncheckin_items'),
                        key: 'uncheckin_items',
                        dataIndex: 'uncheckin_items',
                        align: 'start',
                        render: (text, record, index) => {
                            let barcodeString = record?.checkout_data?.map(item => item?.item_barcode || `館藏編號 ${item?.item_itemnumber ?? '未知'}（無條碼）`).join(',');
                            return <SpecificUserOverdueModal
                                propsIssueCardnumber={record?.cardnumber}
                                propsButtonText={barcodeString}
                                propsOnClose={() => {
                                    setReloadCount((pre) => pre + 1)
                                }}

                            />
                        }
                    },
                    {
                        title: t('borrower_note'),
                        key: 'borrower_note',
                        dataIndex: 'borrower_note',
                        align: 'left',
                        render: (text) => <ExpandableText text={text || ""} maxLines={1} />
                    },
                ]} //列表編輯模式的顯示columns
                propsCardRender={() => { }} //card 模式要顯示的其他欄位
                departmentMode="structure"
                propsPatchProcess={(item) => {
                    return ({
                        ...item,
                        dateexpiry: item?.dateexpiry ? dayjs(item?.dateexpiry).format("YYYY-MM-DD") : null
                    })
                }}
                // readonly={permission_level === 1 ? false : true}
                show_chart={false}
                show_tab_bar={false}
                propsShowKeys={[
                    { key: "additional_attributes", name: "additional_attributes", hidden: false, require: false },
                    { key: "staff_serial_name", name: "staff_serial_name", hidden: false, require: true },
                    { key: "user_department_role_data", name: "user_department_role_data", hidden: false, require: false },
                    { key: "staff_name", name: "staff_name", hidden: false, require: true },
                    { key: "staff_english_name", name: "staff_english_name", hidden: true, require: false },
                    { key: "custom_line_id", name: "custom_line_id", hidden: true, require: false },
                    { key: "gender_name", name: "gender_name", hidden: false, require: false },
                    { key: "staff_phone", name: "staff_phone", hidden: false, require: false },
                    { key: "email", name: "email", hidden: false, require: false },
                    { key: "address", name: "address", hidden: false, require: false },
                    { key: "county_and_city_district_num", name: "county_and_city_district_num", hidden: false, require: false },
                    { key: "property_json", name: "property_json", hidden: false, require: false },
                    { key: "create_user_name", name: "create_user_name", hidden: false, require: false },
                    { key: "create_time", name: "create_time", hidden: false, require: true },
                    { key: "last_edit_user_name", name: "last_edit_user_name", hidden: false, require: false },
                    { key: "last_edit_time", name: "last_edit_time", hidden: false, require: false },
                    { key: "employment_time_end", name: "employment_time_end", hidden: true, require: false },
                    { key: "cardnumber", name: "cardnumber", hidden: true, require: false },
                    { key: "suspension", name: "suspension", hidden: false, require: false },
                    { key: "branchcode", name: "branchcode", hidden: false, require: false },
                    { key: "branchname", name: "branchname", hidden: false, require: false },
                    { key: "borrowercategory", name: "borrowercategory", hidden: false, require: false },
                    { key: "dateexpiry", name: "dateexpiry", hidden: false, require: false },
                    { key: "uncheckin_amount", name: "uncheckin_amount", hidden: false, require: false },
                    { key: "uncheckin_items", name: "uncheckin_items", hidden: false, require: false },
                    { key: "borrower_note", name: "borrower_note", hidden: false, require: false },
                ]}
                toolBarRender={(tool) => {
                    //拿掉不需要的基底按鈕，「匯出人員資料」
                    tool.shift();
                    return [
                        <Col span={24}>
                            <Row gutter={[4, 4]} align={"middle"}>
                                <Col>
                                    <Typography.P>
                                        {/* {t(`Date accessioned`)}: */}
                                        證號過期區間：
                                    </Typography.P>
                                </Col>
                                <Col>
                                    <Input
                                        type="date"
                                        format={"YYYY-MM-DD"}
                                        value={search?.date_expiry_start ? search?.date_expiry_start : ""}
                                        onChange={(e) => {
                                            setSearch((pre) => {
                                                if (dayjs(e.target.value).isBefore(dayjs(pre?.date_expiry_end, "YYYY-MM-DD"))) {
                                                    return {
                                                        ...pre,
                                                        date_expiry_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        date_expiry_start: pre?.date_expiry_end,
                                                        date_expiry_end: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <Typography.Title level={4}>
                                        ~
                                    </Typography.Title>
                                </Col>
                                <Col>
                                    <Input
                                        type="date"
                                        placeholder={t(`.time_end`)}
                                        format={"YYYY-MM-DD"}
                                        value={search?.date_expiry_end ? search?.date_expiry_end : ""}
                                        onChange={(e) => {
                                            setSearch((pre) => {
                                                if ((dayjs(e.target.value)).isBefore(pre?.date_expiry_start)) {
                                                    return {
                                                        ...pre,
                                                        date_expiry_start: e.target.value,
                                                        date_expiry_end: pre?.date_expiry_start,
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        date_expiry_end: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                {(search?.date_expiry_start || search?.date_expiry_end) &&
                                    <Col>
                                        <Button
                                            type={"icon"}
                                            onClick={() => {
                                                setSearch((pre) => {
                                                    return {
                                                        date_expiry_start: undefined,
                                                        date_expiry_end: undefined
                                                    }
                                                })
                                            }}>
                                            X
                                        </Button>
                                    </Col>
                                }
                            </Row>
                        </Col>,

                        <Select
                            placeholder="所屬分館"
                            allowClear={true}
                            value={search?.branchcode}
                            options={LibraryController.ResponseData.map((value) => {
                                return {
                                    value: value?.branchcode,
                                    label: value?.branchname
                                }
                            })}
                            onChange={(value) => {
                                setSearch((pre) => {
                                    return {
                                        ...pre,
                                        branchcode: value
                                    }
                                })
                            }}

                        />,
                        !readonly && <>
                            <ExportButton
                                exportParams={exportParams.current}
                            />
                            {/* <Button
                                loading={exloading}
                                className='example' style={{ background: '#1565C0', color: '#ffffff' }}
                                onClick={e => {
                                    exportData({
                                        ...exportParams.current
                                        // ...exportParams
                                    })
                                }}
                            >
                                匯出讀者清單(含借閱資料)
                                <FontAwesomeIcon icon={faFileExport} style={{ marginLeft: '2px' }} />
                            </Button> */}
                        </>,
                        <StaffPatronProgressModal
                        />
                        ,
                        ...tool
                    ]
                }}
                propsSearchParams={{
                    ...search
                }}
                onSearchParamsChange={(value) => {
                    // setExportParams(value)
                    exportParams.current = value
                }}
            />
        </Col>
    </Row>)
}

const ExportButton = ({ exportParams }) => {
    const [exloading, setExLoading] = useState(false)

    const exportData = (data) => {
        let start_end = ""
        if (!!data?.date_expiry_start && !!data?.date_expiry_end) {
            let start = dayjs(data?.date_expiry_start).format("YYYYMMDD")
            let end = dayjs(data?.date_expiry_end).format("YYYYMMDD")
            start_end = `${start}-${end}`
        }
        setExLoading(true)
        axios.get(`/library/organization_structure/api/staff/concatenation_export/expiration_staff_with_uncheckins`,
            {
                responseType: 'blob',
                params: data,
            },
        )
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${start_end}到期讀者清單.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .finally(() => {
                setExLoading(false)
            })
    }

    return (<Button
        loading={exloading}
        className='example' style={{ background: '#1565C0', color: '#ffffff' }}
        onClick={e => {
            // const { role_id_arr, department_id_arr } = getFormValues(departmentOptionController);
            let newParams = {
                // department_id_arr: department_id_arr.length === 0 ? undefined : `{${department_id_arr.join(',')}}`,
                // role_id_arr_only: role_id_arr.length === 0 ? undefined : `{${role_id_arr.join(',')}}`,
            };

            exportData({
                ...exportParams
                // ...exportParams
            })
        }}
    >
        {/* {t(`export_collection`)}  */}
        匯出讀者清單(含借閱資料)
        <FontAwesomeIcon icon={faFileExport} style={{ marginLeft: '2px' }} />
    </Button>)
}
export default StaffPatron
